import React from 'react'
import "../articles.css"
import calculator from "../../../../assets/images/articles/pexels-don-cockman.jpg"
import { Byline, Published } from "../.."

export default function Article13Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={calculator} alt="calculator"/>
        <div className='emas__articles-container_photo'>
          <i >Photo by Don Cockman, Pexels</i>
        </div>
        <h1>Report on rate of return for energy networks finds returns are too high by almost $1 billion</h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
            <p>February 2025</p>
            <p>We prepared a report for Energy Consumers Australia to submit to the Australian Energy Regulator's review of the Rate of Return Instrument. </p>
            <p>The report includes recommendations for how the AER can address settings that have led to higher than necessary electricity and reticulated gas prices. We estimate that annual network revenue (for aggregate electricity) would have been lower by around 6.4%, or $941 million, if the settings we propose had been in place for the last round of resets.</p>
            <p>The recommendations include lowering equity returns by reducing the equity beta and changing the way inflation is dealt with when compensating providers for the cost of debt.</p>
            <p>The report makes use of our financial model of network service providers operating in the National Electricity Market.</p>
            <p>It was prepared by EMAS and Simon Orme of Tahu Consulting.</p>
            <p>The report is available on the AER's website <a href='https://www.aer.gov.au/documents/eca-attachment-emas-report-energy-consumer-australias-submission-aer-2026-rate-return-instrument-review-december-2025'>here</a>.</p>
        </div>
        <Published />
    </div>
</div>
  )
}
